<span
  class="copyable"
  [class.chip]="variant() === 'chip'"
  [title]="copyTitle()"
  (click)="copy()"
  (mouseleave)="onPointerLeave()"
>
  <span class="label" [class.uppercase]="uppercase()">{{ label() }}</span>
  <span class="copy-icon" [class.copied]="copied()" [class.suppressed]="suppressed()">
    <mat-icon class="glyph glyph-copy">content_copy</mat-icon>
    <mat-icon class="glyph glyph-check">check</mat-icon>
  </span>
</span>
